module.exports = __webpack_public_path__ + "img/Bagong_Pilipinas.ebc21ab0.png";